import React from "react";
import Col from "react-bootstrap/lib/Col";
import { push } from "connected-react-router";
import { Field, Form, Formik } from "formik";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";

import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import { connect } from "react-redux";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import useSchema from "hooks/useSchema";
import { bool, func, shape, string } from "prop-types";

const AmountFilter = ({
    dispatch,
    isSubmitting,
    FieldType,
    formID,
    isDesktop,
    productId,
    setBalanceFalse,
    setBalanceTrue,
    parentSelectedFilter,
    selectedFilter,
    filtersGlobal,
    handleClickHideFilters = null,
    searchByField,
    fixedDecimalScale,
    ...props
}) => {
    const { stringRequired } = useSchema();
    // const MyEnhancedForm = {withFormik({
    const formikProps = {
        validateOnChange: false,
        validateOnBlur: false,
        initialValues: {
            montoMin: { amount: filtersGlobal?.montoMin?.amount, currency: props.currency },
            montoMax: { amount: filtersGlobal?.montoMax?.amount, currency: props.currency },
        },
        validationSchema: () =>
            Yup.object().shape({
                montoMin: Yup.object().shape({
                    amount: stringRequired.test(
                        "min",
                        i18n.get("accounts.movements.filters.amount.min"),
                        // eslint-disable-next-line func-names
                        function(montoMin) {
                            // eslint-disable-next-line react/no-this-in-sfc
                            const { from } = this;
                            const { value } = from[1];
                            const isEmpty = (v) => !v && v !== 0;
                            if (isEmpty(value.montoMax.amount) || isEmpty(montoMin)) {
                                return true;
                            }
                            return Number(montoMin) <= Number(value.montoMax.amount);
                        },
                    ),
                }),
                montoMax: Yup.object().shape({
                    amount: stringRequired.test(
                        "max",
                        i18n.get("accounts.movements.filters.amount.max"),
                        // eslint-disable-next-line func-names
                        function(montoMax) {
                            // eslint-disable-next-line react/no-this-in-sfc
                            const { from } = this;
                            const { value } = from[1];
                            const isEmpty = (v) => !v && v !== 0;
                            if (isEmpty(value.montoMin.amount) || isEmpty(montoMax)) {
                                return true;
                            }
                            return Number(value.montoMin.amount) <= Number(montoMax);
                        },
                    ),
                }),
            }),
        onSubmit: ({ ...filters }, formikBag) => {
            // const { dispatch, isDesktop, productId, setBalanceFalse, parentSelectedFilter, selectedFilter } = formikBag.props;
            const { montoMin, montoMax } = filters;

            if (handleClickHideFilters) {
                handleClickHideFilters();
            }

            setBalanceFalse();

            if (isDesktop) {
                dispatch(
                    accountsActions.setFilterMovements({
                        parentFilter: parentSelectedFilter,
                        selectedFilter,
                        ...filters,
                    }),
                );
                dispatch(
                    accountsActions.details(
                        productId,
                        {
                            parentFilter: parentSelectedFilter,
                            selectedFilter,
                            ...filters,
                            maxAmount: montoMax.amount,
                            minAmount: montoMin.amount,
                        },
                        formikBag,
                    ),
                );
            } else {
                dispatch(
                    accountsActions.setMobileFilter({
                        filter: "amount",
                        ...filters,
                        maxAmount: montoMax.amount,
                        minAmount: montoMin.amount,
                    }),
                );
                dispatch(push(`/accounts/${productId}/filters/results`));
            }
        },
    };

    const handleReset = (allFormikProps) => {
        allFormikProps.setFieldValue("montoMin", null);
        allFormikProps.setFieldValue("montoMax", null);
    };

    return (
        <Formik {...formikProps}>
            {(allFormikProps) => (
                <Form>
                    <Container className="container--layout items-center" gridClassName="form-content">
                        {!!searchByField && (
                            <Col sm={12} md={4}>
                                {searchByField()}
                            </Col>
                        )}
                        <Col sm={12} md={searchByField ? 4 : 6}>
                            <Field
                                component={FieldType}
                                hidePlaceholder
                                idForm={formID}
                                name="montoMin"
                                data={{ options: [{ id: 1, label: i18n.get(`currency.label.${props.currency}`) }] }}
                                disableSelect
                                allowNegative
                                fixedDecimalScale={fixedDecimalScale}
                            />
                        </Col>
                        <Col sm={12} md={searchByField ? 4 : 6}>
                            <Field
                                component={FieldType}
                                hidePlaceholder
                                idForm={formID}
                                name="montoMax"
                                data={{ options: [{ id: 1, label: i18n.get(`currency.label.${props.currency}`) }] }}
                                disableSelect
                                allowNegative
                                fixedDecimalScale={fixedDecimalScale}
                            />
                        </Col>
                        {searchByField ? (
                            <>
                                <Col sm={12} md={6}>
                                    <Button
                                        className="btn-outline"
                                        label="echecks.clean.filters"
                                        onClick={() => handleReset(allFormikProps)}
                                    />
                                </Col>
                                <Col sm={12} md={6}>
                                    <Button
                                        bsStyle="primary"
                                        label="product.filters.filter"
                                        loading={isSubmitting}
                                        type="submit"
                                        block
                                    />
                                </Col>
                            </>
                        ) : (
                            <Col sm={12} className="md:grid-cols-2">
                                <Button
                                    className="btn-outline"
                                    label="echecks.clean.filters"
                                    onClick={() => handleReset(allFormikProps)}
                                />
                                <Button
                                    bsStyle="primary"
                                    label="product.filters.filter"
                                    loading={isSubmitting}
                                    type="submit"
                                    block
                                />
                            </Col>
                        )}
                    </Container>
                </Form>
            )}
        </Formik>
    );
};

AmountFilter.propTypes = {
    dispatch: func.isRequired,
    isSubmitting: bool.isRequired,
    FieldType: func.isRequired,
    formID: string.isRequired,
    currency: string.isRequired,
    isDesktop: bool.isRequired,
    productId: string.isRequired,
    setBalanceFalse: func.isRequired,
    setBalanceTrue: func.isRequired,
    parentSelectedFilter: string.isRequired,
    selectedFilter: string.isRequired,
    filtersGlobal: shape({}).isRequired,
    handleClickHideFilters: func,
    searchByField: func,
    fixedDecimalScale: bool,
};

AmountFilter.defaultProps = {
    handleClickHideFilters: null,
    searchByField: null,
    fixedDecimalScale: false,
};

const mapStateToProps = (state) => ({
    filtersGlobal: accountsSelectors.getFilters(state),
});

export default connect(mapStateToProps)(AmountFilter);
